// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-e-ticket-js": () => import("./../../../src/pages/e-ticket.js" /* webpackChunkName: "component---src-pages-e-ticket-js" */),
  "component---src-pages-generate-qr-js": () => import("./../../../src/pages/generate-qr.js" /* webpackChunkName: "component---src-pages-generate-qr-js" */),
  "component---src-pages-generator-link-js": () => import("./../../../src/pages/generator-link.js" /* webpackChunkName: "component---src-pages-generator-link-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

